import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import NProgress from "nprogress";
import "./ProgressBar.css";

NProgress.configure({ showSpinner: false });

const ProgressBar: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const handleStart = () => NProgress.start();
    const handleStop = () => NProgress.done();

    handleStart();

    // Listen for route changes and handle progress
    handleStop();

    // Clean up
    return () => {
      handleStop();
    };
  }, [location]);

  return null;
};

export default ProgressBar;
